import { render, staticRenderFns } from "./Manypeople.vue?vue&type=template&id=adadf5fe&scoped=true"
import script from "./Manypeople.vue?vue&type=script&lang=js"
export * from "./Manypeople.vue?vue&type=script&lang=js"
import style0 from "./Manypeople.vue?vue&type=style&index=0&id=adadf5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adadf5fe",
  null
  
)

export default component.exports